import axios from '@/_services/axios';

export function GetMeasurements(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${id}/measurements`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetAll(take, skip, locked, order, search = '') {
  const url =
    locked !== null
      ? `jobs?take=${take}&skip=${skip}&locked=${locked}&order=${order}&search=${search}`
      : `jobs?take=${take}&skip=${skip}&order=${order}&search=${search}`;
  return new Promise((resolve, reject) => {
    axios
      .get(url)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Remove(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`jobs/${id}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Duplicate(id) {
  return new Promise((resolve, reject) => {
    axios
      .post(`jobs/${id}/duplicate`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function Save(job) {
  if (job.id === 0) {
    return Create(job);
  }
  return Edit(job);
}

export function Create(item) {
  return new Promise((resolve, reject) => {
    axios
      .post('jobs/new', {
        name: item.name,
        laborType: item.laborType,
        tasks: item.tasks,
      })
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

function Edit(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${item.id}`, item)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditInfo(item) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${item.id}/jobInfo`, item)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function UpdateFrais(jobId, frais) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/jobFees`, frais)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditMeasurements(jobId, measurements) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/measurements`, measurements)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPrices(jobId, phasesId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phases/${phasesId}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPhases(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phases`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPhaseComposites(jobId, phaseId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phases/${phaseId}`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPhaseSummary(jobId, phaseId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phases/${phaseId}/summary`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function EditMaterialQuantity(id, compositePrototypeId, compositeMaterialPrototypeId, quantity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${id}/composite/${compositePrototypeId}/materials/${compositeMaterialPrototypeId}`, {
        quantity: quantity,
      })
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function ToggleLock(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/toggleLockState`)
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function Lock(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/lock`)
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function Unlock(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/unlock`)
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function MeasurementsFormatSave(jobParam) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobParam.id}/measurementsformat`, jobParam)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function AddComposite(jobId, compositePrototypeId) {
  return new Promise((resolve, reject) => {
    axios
      .post(`jobs/${jobId}/composites/${compositePrototypeId}`)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function RemoveComposite(jobId, compositePrototypeId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`jobs/${jobId}/composites/${compositePrototypeId}`)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function AddMaterial(compositeId, compositeMaterialPrototypeId) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${compositeId}/materials`, compositeMaterialPrototypeId)
      .then(res => resolve(res.data))
      .catch(err => reject(err));
  });
}

export function UpdateClientInfo(jobId, data) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/clientInfo`, data)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function UpdateProjectInfo(jobId, data) {
  return new Promise((resolve, reject) => {
    axios
      .put(`jobs/${jobId}/projectInfo`, data)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetClientInfo(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/clientInfo`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetProjectInfo(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/projectInfo`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetPhaseDetails(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phaseDetails`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetAllPhaseDetails(jobId) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/phaseDetailsIncludeEmpty`)
      .then(resp => resolve(resp.data))
      .catch(err => reject(err));
  });
}

export function GetReport(jobId, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/report`, { params, responseType: 'blob' })
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}

export function DownloadReport(jobId, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(`jobs/${jobId}/downloadReport`, { params, responseType: 'blob' })
      .then(resp => resolve(resp))
      .catch(err => reject(err));
  });
}
